"use strict";

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CharacterCounter = function CharacterCounter(props) {
  var charCounterClasses = (0, _classnames.default)('character-counter', {
    'is-error': props.value < 0
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: charCounterClasses,
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-relevant": "all"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "vh"
  }, props.a11yPrefix), "".concat(props.prefix).concat(props.value).concat(props.suffix), /*#__PURE__*/_react.default.createElement("span", {
    className: "vh"
  }, props.a11ySuffix));
};

CharacterCounter.defaultProps = {
  value: 1000,
  prefix: '',
  a11yPrefix: '',
  suffix: '',
  a11ySuffix: 'characters remaining'
};
CharacterCounter.propTypes = {
  value: _propTypes.default.number,
  prefix: _propTypes.default.string,
  a11yPrefix: _propTypes.default.string,
  suffix: _propTypes.default.string,
  a11ySuffix: _propTypes.default.string
};
var _default = CharacterCounter;
exports.default = _default;
//# sourceMappingURL=CharacterCounter.js.map